export const messages = {
  it: {
    siteName: 'Wyrd Grove',
    tagline: 'Miniature e creazioni artigianali',
    navHome: 'Home',
    navOriginalArtworks: 'Tavole Originali',
    navPrints: 'Stampe',
    navMiniatures: 'Miniature',
    navFiles: 'File',
    navLinks: 'Link',
    topBarMessage:
      'Acquisti su Etsy, Ko-fi e altri shop — il sito è una vetrina delle mie creazioni',
    breadcrumbHome: 'Home',
    breadcrumbOriginalArtworks: 'Tavole Originali',
    breadcrumbPrints: 'Stampe',
    breadcrumbMiniatures: 'Miniature',
    breadcrumbFiles: 'File',
    filterSidebar: 'Filtra',
    miniaturesResults: '{count} miniature trovate',
    filesResults: '{count} file trovati',
    originalArtworksResults: '{count} tavole trovate',
    printsResults: '{count} stampe trovate',
    tabDescription: 'Descrizione',
    tabDetails: 'Dettagli',
    footerNewsletter: 'Resta nel bosco',
    footerNewsletterText: 'Tutti i nostri link in un solo posto.',
    footerNewsletterCta: 'Vai ai link',
    footerAbout:
      'Miniature modellate in 3D, stampate e dipinte a mano.\nOgni pezzo è unico.',
    footerExplore: 'Esplora',
    footerRights: 'Tutti i diritti riservati.',
    featuredMiniatures: 'Miniature in evidenza',
    featuredFiles: 'File stampabili in evidenza',
    featuredOriginalArtworks: 'Tavole originali in evidenza',
    featuredPrints: 'Stampe in evidenza',
    heroTitle: 'Wyrd Grove',
    viewMiniatures: 'Sfoglia le miniature',
    viewPrintableFiles: 'Sfoglia i file stampabili',
    viewOriginalArtworks: 'Sfoglia le tavole originali',
    viewPrints: 'Sfoglia le stampe',
    featured: 'In evidenza',
    viewAllMiniatures: 'Vedi tutte le miniature',
    viewAllFiles: 'Vedi tutti i file',
    viewAllOriginalArtworks: 'Vedi tutte le tavole',
    viewAllPrints: 'Vedi tutte le stampe',
    homeMosaic: 'Selezione miniature',
    homeMorePieces: 'Altri pezzi',
    allMiniatures: 'Tutte le miniature',
    allFiles: 'Tutti i file',
    allOriginalArtworks: 'Tutte le tavole originali',
    allPrints: 'Tutte le stampe',
    filterCategory: 'Categoria',
    filterMaterial: 'Materiale',
    filterAll: 'Tutte',
    noMiniatures: 'Nessuna miniatura pubblicata al momento.',
    noFiles: 'Nessun file pubblicato al momento.',
    noOriginalArtworks: 'Nessuna tavola originale pubblicata al momento.',
    noPrints: 'Nessuna stampa pubblicata al momento.',
    soldOut: 'Esaurito',
    soldOutNote: 'Questo pezzo è stato venduto. Resta in vetrina come riferimento.',
    relatedFile: 'File digitale',
    relatedMiniature: 'Miniatura dipinta collegata',
    relatedMiniatures: 'Miniature dipinte da questo file',
    relatedArtwork: 'Tavola originale',
    relatedPrint: 'Stampa',
    relatedPrints: 'Stampe di questa tavola',
    unavailable: 'Non disponibile',
    buyOn: 'Acquista su',
    zoomImage: 'Ingrandisci immagine',
    closeLightbox: 'Chiudi',
    lightboxPrev: 'Immagine precedente',
    lightboxNext: 'Immagine successiva',
    lightboxImageOf: '{current} di {total}',
    openShop: 'Apri shop',
    productDetails: 'Dettagli',
    material: 'Materiale',
    technique: 'Tecnica',
    categories: 'Categorie',
    tags: 'Tag',
    notFound: 'Miniatura non trovata',
    notFoundFile: 'File non trovato',
    notFoundArtwork: 'Tavola non trovata',
    notFoundPrint: 'Stampa non trovata',
    purchaseNote:
      'Il prezzo è indicativo. Pagamento e spedizione sono gestiti dal marketplace selezionato.',
    fileDownloadNote:
      'Il prezzo è indicativo. Il download o l’acquisto avviene sul canale indicato.',
    loading: 'Caricamento…',
    errorLoad: 'Impossibile caricare le miniature. Riprova più tardi.',
    errorLoadFiles: 'Impossibile caricare i file. Riprova più tardi.',
    errorLoadArtworks: 'Impossibile caricare le tavole. Riprova più tardi.',
    errorLoadPrints: 'Impossibile caricare le stampe. Riprova più tardi.',
    errorLoadLinks: 'Impossibile caricare i link. Riprova più tardi.',
    language: 'Lingua',
    globalShops: 'Dove acquistare',
    linksPageDefaultTagline: '🐦‍⬛ Wyrd Grove by Pot\n🌲 Artista multimediale che esplora natura, animali e fantasy.\n🎨 Dall\'inchiostro su carta a sculture 3D e accessori indossabili.',
    linksPageEmpty: 'Nessun link pubblicato ancora.',
    linksPageNav: 'Collegamenti',
    linksPageCategoryShops: 'Negozi',
    linksPageCategorySocials: 'Social',
    seoDescriptionMiniatures:
      'Miniature modellate in 3D, stampate e dipinte a mano. Sfoglia il catalogo Wyrd Grove.',
    seoDescriptionFiles:
      'File stampabili 3D: modelli digitali per la tua stampante. Sfoglia i file Wyrd Grove.',
    seoDescriptionOriginalArtworks:
      'Tavole originali disegnate a mano. Sfoglia le tavole Wyrd Grove.',
    seoDescriptionPrints:
      'Stampe delle tavole Wyrd Grove. Sfoglia il catalogo.',
    seoDescriptionLinks:
      'Tutti i link Wyrd Grove: negozi, social e commissioni in un solo posto.',
  },
  en: {
    siteName: 'Wyrd Grove',
    tagline: 'Handcrafted miniatures & creations',
    navHome: 'Home',
    navOriginalArtworks: 'Hand-Drawn Originals',
    navPrints: 'Prints',
    navMiniatures: 'Miniatures',
    navFiles: 'Files',
    navLinks: 'Links',
    topBarMessage:
      'Shop on Etsy, Ko-fi and more — this site showcases my handcrafted work',
    breadcrumbHome: 'Home',
    breadcrumbOriginalArtworks: 'Hand-Drawn Originals',
    breadcrumbPrints: 'Prints',
    breadcrumbMiniatures: 'Miniatures',
    breadcrumbFiles: 'Files',
    filterSidebar: 'Filter',
    miniaturesResults: '{count} miniatures found',
    filesResults: '{count} files found',
    originalArtworksResults: '{count} originals found',
    printsResults: '{count} prints found',
    tabDescription: 'Description',
    tabDetails: 'Details',
    footerNewsletter: 'Stay in the grove',
    footerNewsletterText: 'All our links in one place.',
    footerNewsletterCta: 'Go to links',
    footerAbout:
      'Miniatures modeled in 3D, printed and hand-painted.\nEach piece is one of a kind.',
    footerExplore: 'Explore',
    footerRights: 'All rights reserved.',
    featuredMiniatures: 'Featured miniatures',
    featuredFiles: 'Featured printable files',
    featuredOriginalArtworks: 'Featured hand-drawn originals',
    featuredPrints: 'Featured prints',
    heroTitle: 'Wyrd Grove',
    viewMiniatures: 'Browse miniatures',
    viewPrintableFiles: 'Browse printable files',
    viewOriginalArtworks: 'Browse hand-drawn originals',
    viewPrints: 'Browse prints',
    featured: 'Featured',
    viewAllMiniatures: 'View all miniatures',
    viewAllFiles: 'View all files',
    viewAllOriginalArtworks: 'View all originals',
    viewAllPrints: 'View all prints',
    homeMosaic: 'Miniature selection',
    homeMorePieces: 'More pieces',
    allMiniatures: 'All miniatures',
    allFiles: 'All files',
    allOriginalArtworks: 'All hand-drawn originals',
    allPrints: 'All prints',
    filterCategory: 'Category',
    filterMaterial: 'Material',
    filterAll: 'All',
    noMiniatures: 'No miniatures published at the moment.',
    noFiles: 'No files published at the moment.',
    noOriginalArtworks: 'No hand-drawn originals published at the moment.',
    noPrints: 'No prints published at the moment.',
    soldOut: 'Sold out',
    soldOutNote: 'This piece has been sold. It remains on display for reference.',
    relatedFile: 'Digital file',
    relatedMiniature: 'Related painted miniature',
    relatedMiniatures: 'Painted miniatures from this file',
    relatedArtwork: 'Hand-drawn original',
    relatedPrint: 'Print',
    relatedPrints: 'Prints of this original',
    unavailable: 'Unavailable',
    buyOn: 'Buy on',
    zoomImage: 'Enlarge image',
    closeLightbox: 'Close',
    lightboxPrev: 'Previous image',
    lightboxNext: 'Next image',
    lightboxImageOf: '{current} of {total}',
    openShop: 'Open shop',
    productDetails: 'Details',
    material: 'Material',
    technique: 'Technique',
    categories: 'Categories',
    tags: 'Tags',
    notFound: 'Miniature not found',
    notFoundFile: 'File not found',
    notFoundArtwork: 'Original not found',
    notFoundPrint: 'Print not found',
    purchaseNote:
      'Price is indicative. Payment and shipping are handled by the selected marketplace.',
    fileDownloadNote:
      'Price is indicative. Download or purchase happens on the linked channel.',
    loading: 'Loading…',
    errorLoad: 'Could not load miniatures. Please try again later.',
    errorLoadFiles: 'Could not load files. Please try again later.',
    errorLoadArtworks: 'Could not load originals. Please try again later.',
    errorLoadPrints: 'Could not load prints. Please try again later.',
    errorLoadLinks: 'Could not load links. Please try again later.',
    language: 'Language',
    globalShops: 'Where to buy',
    linksPageDefaultTagline: '🐦‍⬛ Wyrd Grove by Pot\n🌲 Mixed-media artist exploring nature, animals & fantasy.\n🎨 From ink-on-paper to 3D sculptures & wearables.',
    linksPageEmpty: 'No links published yet.',
    linksPageNav: 'Links',
    linksPageCategoryShops: 'Shops',
    linksPageCategorySocials: 'Socials',
    seoDescriptionMiniatures:
      '3D modeled, printed and hand-painted miniatures. Browse the Wyrd Grove catalog.',
    seoDescriptionFiles:
      'Printable 3D files and digital models. Browse Wyrd Grove downloads.',
    seoDescriptionOriginalArtworks:
      'Hand-drawn originals. Browse the Wyrd Grove collection.',
    seoDescriptionPrints:
      'Prints of Wyrd Grove originals. Browse the catalog.',
    seoDescriptionLinks:
      'All Wyrd Grove links: shops, socials and more in one place.',
  },
}

/** Ordine sezioni su /links */
export const linksPageCategoryOrder = ['general', 'shops', 'socials']

export const categoryLabels = {
  animali: { it: 'Animali', en: 'Animals' },
  fantasy: { it: 'Fantasy', en: 'Fantasy' },
  pokemon: { it: 'Pokémon', en: 'Pokémon' },
}

export const materialLabels = {
  pla: { it: 'PLA', en: 'PLA' },
  petg: { it: 'PETG', en: 'PETG' },
  resin: { it: 'Resina', en: 'Resin' },
  abs_like_resin: { it: 'Resina ABS-like', en: 'ABS-like resin' },
  official_model: { it: 'Modello ufficiale', en: 'Official model' },
}

export const platformLabels = {
  instagram: { it: 'Instagram', en: 'Instagram' },
  facebook: { it: 'Facebook', en: 'Facebook' },
  etsy: { it: 'Etsy', en: 'Etsy' },
  kofi: { it: 'Ko-Fi', en: 'Ko-Fi' },
  cults: { it: 'Cults 3D', en: 'Cults 3D' },
  youtube: { it: 'YouTube', en: 'YouTube' },
  tiktok: { it: 'TikTok', en: 'TikTok' },
  pinterest: { it: 'Pinterest', en: 'Pinterest' },
  bluesky: { it: 'Bluesky', en: 'Bluesky' },
  x: { it: 'X', en: 'X' },
  website: { it: 'Sito', en: 'Website' },
  email: { it: 'Email', en: 'Email' },
  other: { it: 'Link', en: 'Link' },
}
